import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=67483dac&scoped=true"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"
import style0 from "./Project.vue?vue&type=style&index=0&id=67483dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67483dac",
  null
  
)

export default component.exports